/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AgendaRouteImport } from './routes/agenda'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as FichaSlugRouteImport } from './routes/ficha.$slug'
import { Route as ClientesRouteImport } from './routes/clientes'
import { Route as ConfiguracoesRouteImport } from './routes/configuracoes'
import { Route as EstoqueRouteImport } from './routes/estoque'
import { Route as FinanceiroRouteImport } from './routes/financeiro'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as ClientesIndexRouteImport } from './routes/clientes.index'
import { Route as ClientesClienteIdRouteImport } from './routes/clientes.$clienteId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaRoute = AgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const CadastroRoute = CadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => rootRouteImport,
} as any)
const FichaSlugRoute = FichaSlugRouteImport.update({
  id: '/ficha/$slug',
  path: '/ficha/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientesRoute = ClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguracoesRoute = ConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => rootRouteImport,
} as any)
const EstoqueRoute = EstoqueRouteImport.update({
  id: '/estoque',
  path: '/estoque',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceiroRoute = FinanceiroRouteImport.update({
  id: '/financeiro',
  path: '/financeiro',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientesIndexRoute = ClientesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientesRoute,
} as any)
const ClientesClienteIdRoute = ClientesClienteIdRouteImport.update({
  id: '/$clienteId',
  path: '/$clienteId',
  getParentRoute: () => ClientesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/agenda': typeof AgendaRoute
  '/cadastro': typeof CadastroRoute
  '/clientes': typeof ClientesRouteWithChildren
  '/configuracoes': typeof ConfiguracoesRoute
  '/estoque': typeof EstoqueRoute
  '/financeiro': typeof FinanceiroRoute
  '/login': typeof LoginRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/ficha/$slug': typeof FichaSlugRoute
  '/clientes/$clienteId': typeof ClientesClienteIdRoute
  '/clientes/': typeof ClientesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/agenda': typeof AgendaRoute
  '/cadastro': typeof CadastroRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/estoque': typeof EstoqueRoute
  '/financeiro': typeof FinanceiroRoute
  '/login': typeof LoginRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/ficha/$slug': typeof FichaSlugRoute
  '/clientes/$clienteId': typeof ClientesClienteIdRoute
  '/clientes': typeof ClientesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/agenda': typeof AgendaRoute
  '/cadastro': typeof CadastroRoute
  '/clientes': typeof ClientesRouteWithChildren
  '/configuracoes': typeof ConfiguracoesRoute
  '/estoque': typeof EstoqueRoute
  '/financeiro': typeof FinanceiroRoute
  '/login': typeof LoginRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/ficha/$slug': typeof FichaSlugRoute
  '/clientes/$clienteId': typeof ClientesClienteIdRoute
  '/clientes/': typeof ClientesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/agenda'
    | '/cadastro'
    | '/clientes'
    | '/configuracoes'
    | '/estoque'
    | '/financeiro'
    | '/login'
    | '/redefinir-senha'
    | '/ficha/$slug'
    | '/clientes/$clienteId'
    | '/clientes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/agenda'
    | '/cadastro'
    | '/configuracoes'
    | '/estoque'
    | '/financeiro'
    | '/login'
    | '/redefinir-senha'
    | '/ficha/$slug'
    | '/clientes/$clienteId'
    | '/clientes'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/agenda'
    | '/cadastro'
    | '/clientes'
    | '/configuracoes'
    | '/estoque'
    | '/financeiro'
    | '/login'
    | '/redefinir-senha'
    | '/ficha/$slug'
    | '/clientes/$clienteId'
    | '/clientes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AgendaRoute: typeof AgendaRoute
  CadastroRoute: typeof CadastroRoute
  ClientesRoute: typeof ClientesRouteWithChildren
  ConfiguracoesRoute: typeof ConfiguracoesRoute
  EstoqueRoute: typeof EstoqueRoute
  FinanceiroRoute: typeof FinanceiroRoute
  LoginRoute: typeof LoginRoute
  RedefinirSenhaRoute: typeof RedefinirSenhaRoute
  FichaSlugRoute: typeof FichaSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda': {
      id: '/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cadastro': {
      id: '/cadastro'
      path: '/cadastro'
      fullPath: '/cadastro'
      preLoaderRoute: typeof CadastroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clientes': {
      id: '/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof ClientesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuracoes': {
      id: '/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof ConfiguracoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estoque': {
      id: '/estoque'
      path: '/estoque'
      fullPath: '/estoque'
      preLoaderRoute: typeof EstoqueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financeiro': {
      id: '/financeiro'
      path: '/financeiro'
      fullPath: '/financeiro'
      preLoaderRoute: typeof FinanceiroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir-senha': {
      id: '/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof RedefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ficha/$slug': {
      id: '/ficha/$slug'
      path: '/ficha/$slug'
      fullPath: '/ficha/$slug'
      preLoaderRoute: typeof FichaSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clientes/': {
      id: '/clientes/'
      path: '/'
      fullPath: '/clientes/'
      preLoaderRoute: typeof ClientesIndexRouteImport
      parentRoute: typeof ClientesRoute
    }
    '/clientes/$clienteId': {
      id: '/clientes/$clienteId'
      path: '/$clienteId'
      fullPath: '/clientes/$clienteId'
      preLoaderRoute: typeof ClientesClienteIdRouteImport
      parentRoute: typeof ClientesRoute
    }
  }
}

interface ClientesRouteChildren {
  ClientesClienteIdRoute: typeof ClientesClienteIdRoute
  ClientesIndexRoute: typeof ClientesIndexRoute
}

const ClientesRouteChildren: ClientesRouteChildren = {
  ClientesClienteIdRoute: ClientesClienteIdRoute,
  ClientesIndexRoute: ClientesIndexRoute,
}

const ClientesRouteWithChildren = ClientesRoute._addFileChildren(
  ClientesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AgendaRoute: AgendaRoute,
  CadastroRoute: CadastroRoute,
  ClientesRoute: ClientesRouteWithChildren,
  ConfiguracoesRoute: ConfiguracoesRoute,
  EstoqueRoute: EstoqueRoute,
  FinanceiroRoute: FinanceiroRoute,
  LoginRoute: LoginRoute,
  RedefinirSenhaRoute: RedefinirSenhaRoute,
  FichaSlugRoute: FichaSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
